import React from "react";
import OutwaredBinReportTable from "../../Comman/OutwaredBinReportTable";

const GSM_BinStatus = ({ userData }) => {
  return <OutwaredBinReportTable location="garment_super_market" />;
};

export default GSM_BinStatus;